import request from '@/utils/request';

export async function apiAppData(params = {}) {
    return request({
        url: '/api/app/data',
        params
    });
}

/**
 * 时间搜集
 */
export async function apiAppDataCollect(params = {}) {
    return request({
        url: '/api/app/data/collect',
        params
    });
}

export async function apiAppDataReport(params = {}) {
    return request({
        url: '/api/app/data/report',
        params
    });
}


export function apiAppDataImage(image: File, watermark = 0, type: string = '') {
    const data = new FormData()
    data.set('image', image, image.name)
    if (watermark) {
        data.set('watermark', '1')
    }
    if (type) {
        data.set('image_type', type)
    }
    return request({
        url: 'api/app/data/image',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        params: data
    });
}